( function () {
	function initReviewsSlider() {
		if ( 'undefined' === typeof window.Swiper ) {
			return;
		}

		document
			.querySelectorAll( '.single-bakery-reviews.swiper' )
			.forEach( function ( element ) {
				if ( element.swiper ) {
					return;
				}

				new window.Swiper( element, {
					slidesPerView: 1,
					spaceBetween: 20,
					speed: 450,
					navigation: {
						prevEl: element.querySelector(
							'.single-bakery-reviews__prev'
						),
						nextEl: element.querySelector(
							'.single-bakery-reviews__next'
						),
					},
					breakpoints: {
						768: {
							slidesPerView: 2,
						},
						1100: {
							slidesPerView: 3,
						},
					},
				} );
			} );
	}

	function initGalleryLightbox() {
		if (
			'undefined' === typeof window.PhotoSwipeLightbox ||
			'undefined' === typeof window.PhotoSwipe
		) {
			return;
		}

		document
			.querySelectorAll( '[data-bakery-gallery]' )
			.forEach( function ( gallery ) {
				if ( gallery.dataset.lightboxReady === '1' ) {
					return;
				}

				const lightbox = new window.PhotoSwipeLightbox( {
					gallery,
					children: 'a',
					pswpModule: window.PhotoSwipe,
					showHideAnimationType: 'zoom',
				} );

				lightbox.init();
				gallery.dataset.lightboxReady = '1';
			} );
	}

	function initReviewModal() {
		const modal = document.querySelector( '[data-review-modal]' );

		if ( ! modal ) {
			return;
		}

		const openButtons = document.querySelectorAll( '[data-review-open]' );
		const closeButtons = modal.querySelectorAll( '[data-review-close]' );

		function openModal() {
			modal.hidden = false;
			document.documentElement.classList.add( 'has-single-bakery-modal' );
		}

		function closeModal() {
			modal.hidden = true;
			document.documentElement.classList.remove(
				'has-single-bakery-modal'
			);
		}

		openButtons.forEach( function ( button ) {
			button.addEventListener( 'click', openModal );
		} );

		closeButtons.forEach( function ( button ) {
			button.addEventListener( 'click', closeModal );
		} );

		document.addEventListener( 'keydown', function ( event ) {
			if ( 'Escape' === event.key && ! modal.hidden ) {
				closeModal();
			}
		} );
	}

	function initShowcaseModal() {
		const modal = document.querySelector( '[data-showcase-modal]' );

		if ( ! modal ) {
			return;
		}

		const title = modal.querySelector( '[data-showcase-modal-title]' );
		const description = modal.querySelector(
			'[data-showcase-modal-description]'
		);
		const price = modal.querySelector( '[data-showcase-modal-price]' );
		const image = modal.querySelector( '[data-showcase-modal-image]' );
		const placeholder = modal.querySelector(
			'[data-showcase-modal-placeholder]'
		);
		const openButtons = document.querySelectorAll( '[data-showcase-open]' );
		const closeButtons = modal.querySelectorAll( '[data-showcase-close]' );

		function openModal( button ) {
			const { showcaseTitle, showcaseDescription, showcasePrice } =
				button.dataset;
			const imageUrl = button.dataset.showcaseImage || '';

			title.textContent = showcaseTitle || '';
			description.textContent = showcaseDescription || '';

			if ( showcasePrice ) {
				price.hidden = false;
				price.textContent = showcasePrice;
			} else {
				price.hidden = true;
				price.textContent = '';
			}

			if ( imageUrl ) {
				image.hidden = false;
				image.src = imageUrl;
				image.alt = showcaseTitle || '';
				placeholder.hidden = true;
			} else {
				image.hidden = true;
				image.src = '';
				image.alt = '';
				placeholder.hidden = false;
			}

			modal.hidden = false;
			document.documentElement.classList.add( 'has-single-bakery-modal' );
		}

		function closeModal() {
			modal.hidden = true;
			document.documentElement.classList.remove(
				'has-single-bakery-modal'
			);
		}

		openButtons.forEach( function ( button ) {
			button.addEventListener( 'click', function () {
				openModal( button );
			} );
		} );

		closeButtons.forEach( function ( button ) {
			button.addEventListener( 'click', closeModal );
		} );

		document.addEventListener( 'keydown', function ( event ) {
			if ( 'Escape' === event.key && ! modal.hidden ) {
				closeModal();
			}
		} );
	}

	function init() {
		initReviewsSlider();
		initGalleryLightbox();
		initReviewModal();
		initShowcaseModal();

		if (
			window.SweettySpaceBakeryCard &&
			'function' === typeof window.SweettySpaceBakeryCard.init
		) {
			window.SweettySpaceBakeryCard.init();
		}
	}

	if ( 'loading' === document.readyState ) {
		document.addEventListener( 'DOMContentLoaded', init, { once: true } );
	} else {
		init();
	}
} )();
